import { Modal, Tabs, rem } from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

type AddCameraModalWithTabsProps = {
  opened: boolean
  addTab: ReactNode
  importTab: ReactNode
  onClose: () => void
}

export const AddCameraModalWithTabs = ({
  opened,
  addTab,
  importTab,
  onClose
}: AddCameraModalWithTabsProps) => {
  return (
    <Modal
      opened={opened}
      size="xl"
      title={<FormattedMessage id="cameras.add" />}
      onClose={onClose}
    >
      <Tabs
        defaultValue="add"
        variant="outline"
        styles={{
          panel: {
            marginTop: rem(24)
          }
        }}
      >
        <Tabs.List>
          <Tabs.Tab value="add">
            <FormattedMessage id="cameras.add.new" />
          </Tabs.Tab>

          <Tabs.Tab value="import">
            <FormattedMessage id="cameras.import.fromMilestone" />
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="add">{addTab}</Tabs.Panel>
        <Tabs.Panel value="import">{importTab}</Tabs.Panel>
      </Tabs>
    </Modal>
  )
}
